// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WireSharkIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="url(#wire-shark_svga)"
      fillRule="evenodd"
      d="M21.54 4.46V19.5a2 2 0 0 1-2 2H4.46a2 2 0 0 1-2-2V4.46c0-1.1.9-2 2-2h15.08a2 2 0 0 1 2 2"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M22 4.46V19.5c0 1.36-1.1 2.46-2.46 2.46H4.46A2.46 2.46 0 0 1 2 19.5V4.46C2 3.1 3.1 2 4.46 2h15.08C20.9 2 22 3.1 22 4.46m-.91 11.65V4.46c0-.86-.7-1.55-1.55-1.55H4.46c-.86 0-1.55.7-1.55 1.55V16.1h4.11c.26-1.86 1.82-9.64 9.54-9.77a.43.43 0 0 1 .37.67c-2.26 3.54-.69 8.01-.24 9.1zm-18.18.86v2.54c0 .86.7 1.55 1.55 1.55h15.08c.86 0 1.55-.7 1.55-1.55v-2.54H16.4a.4.4 0 0 1-.39-.25s-2.36-5.17-.2-9.48c-7.33.69-7.98 9.34-7.98 9.34-.02.22-.2.4-.43.4z"
      clipRule="evenodd"
    />
    <path
      fill="url(#wire-shark_svgb)"
      d="M3.42 2.54c1.5-.3 15.29-.4 17 0 1.61.38-4.4 5.6-8.4 5.6s-10.1-5.29-8.6-5.6"
    />
    <defs>
      <radialGradient
        id="wire-shark_svga"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(10 0 0 9.9846 12.6 11)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#40B2E7" />
        <stop offset={1} stopColor="#1679A7" stopOpacity={0.94} />
      </radialGradient>
      <linearGradient
        id="wire-shark_svgb"
        x1={9.55}
        x2={9.67}
        y1={2.83}
        y2={5.74}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8D8D8" stopOpacity={0.82} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.01} />
      </linearGradient>
    </defs>
  </svg>,
  "WireShark",
);
export default WireSharkIcon;
